import React from 'react'

function CheckoutSteps({ stage }) {
    return (
        <div className='flex justify-center mb-6'>
            <ul className="steps w-9/12 md:w-7/12 lg:w-5/12">
                <li className="step step-secondary">Cart</li>
                <li className="step step-secondary">Delivery</li>
                <li className={stage > 0 ? "step step-secondary":"step"}>Payment</li>
            </ul>
        </div>
    )
}

export default CheckoutSteps